import { all, put, takeLatest } from 'redux-saga/effects';
import {
  userConfigAction,
  getUserValidated,
  validateCheckUser,
} from './actions';

import api from '../../services/api';

export function* validateCheckUserSaga(
  action: ReturnType<typeof validateCheckUser>
) {
  const response: ConfigUser = yield api.validateUser(
    action.payload.hashId,
    action.payload.campaignId
  );

  yield put(getUserValidated(response));
}

export default all([
  takeLatest(userConfigAction.getCredential, validateCheckUserSaga),
]);
